import { useCheckPermissions } from '@/shared';
import { SaveSubcategoriaIncidente } from '../../shared/components/SaveSubcategoriaIncidente';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CrearSubcategoriaIncidenteInterface {}

const CrearSubcategoriaIncidente: React.FC<CrearSubcategoriaIncidenteInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_categoria_producto)
  return <SaveSubcategoriaIncidente titlePage="Crear Subcategoría incidencia" />;
};

export default CrearSubcategoriaIncidente;
